import { Navigate } from "@tanstack/react-router";
import { useSmartrrVendorSelector } from "@vendor-app/app/_state/typedVendorReduxHooks";
import { SellingPlansProvider } from "./libs/providers/SellingPlansProvider";
import { SubscriptionDetails } from "./SubscriptionDetails";
import useSubscriptionEligibility from "../AdminSetupRoute/Tabs/SubscriptionSetup/libs/hooks/useSubscriptionEligibility";
import { IS_SANDBOX_FRONTEND } from "@smartrr/shared/constants";
import { useSmartrrFlags } from "@smartrr/shared/LaunchDarkly";

export function AdminSubscriptionDetailsRoute({ subscriptionId }: { subscriptionId: string }): JSX.Element {
  const { eligibleForSubscriptions } = useSubscriptionEligibility();
  const isSuperUser = useSmartrrVendorSelector(state => state.auth.user?.isSuperUser);
  const { vendorPortalGettingStartedPage: gettingStartedFeatureFlagEnabled } = useSmartrrFlags();

  if (gettingStartedFeatureFlagEnabled && !eligibleForSubscriptions && !isSuperUser && !IS_SANDBOX_FRONTEND) {
    return <Navigate to="/admin/getting-started" />;
  }

  if (!eligibleForSubscriptions && !isSuperUser && !IS_SANDBOX_FRONTEND) {
    return <Navigate to="/admin/setup" />;
  }

  return (
    <SellingPlansProvider>
      <SubscriptionDetails subscriptionId={subscriptionId} />
    </SellingPlansProvider>
  );
}
